import React, { useEffect, useState } from "react";
import Common from "us.common";
import { TemplateDrawerType } from "us.collection.case/constants";
import { Email, Editor, MessageTemplateDetail } from "./Components";
import { IEmailFormData } from "us.collection.case/components/MessageTemplates/Interface";
import { RootState } from "us.helper/types";
import { ConnectedProps, connect } from "react-redux";
import {
  MessageAndNoteAction,
  messageTemplateAction,
} from "us.collection.case/actions";
import { messageTemplateInitial } from "us.collection.case/reducers/MassageTemplates/State";
import {
  ExecuteTemplate,
  GetBasicDataRequest,
  GetTemplateV2Request,
  SendEmail,
} from "us.collection.case/repository";
import { getReceiverEmailForV2 } from "us.collection.case/components/MessageTemplates/Function";
import { getCaseNumberAndType } from "us.collection/functions";
import { useLocation } from "react-router-dom";

const { $Drawer } = Common.Components;

/**
 * @description - Template Drawer
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 2023
 */

const TemplateDrawer: React.FC<PropsFromRedux> = (props) => {
  const {
    domainMessageBasicData,
    metaData,
    messageTemplateContent,
    templateDrawer,
    isEmailSending,
    isTemplateExecuting,
    getTemplateContent,
    getBasicData,
    handleDrawer,
    sendTemplate,
    executeTemplate,
  } = props;

  const location = useLocation();
  const [content, setContent] = useState<Array<string>>([]);

  const { caseId, arId } = metaData.data ?? {};
  const { visible, isPreview, templateDetails } = templateDrawer ?? {};
  const { templateId, templateName, templateCategory, plugin } =
    templateDetails ?? {};
  const { data } = messageTemplateContent ?? {};
  const { type: entityType } =
    getCaseNumberAndType(location, metaData.data) ?? {};

  useEffect(() => {
    if (visible && templateId) {
      const templateContentRequest = GetTemplateV2Request.call({
        templateId,
        caseId,
        arId,
        entityType,
        templateName,
        templateCategory,
        plugin,
        isPreview,
      });
      getTemplateContent && getTemplateContent(templateContentRequest);
    }
    if (
      !isPreview &&
      visible &&
      domainMessageBasicData?.entityDetails?.length == 0
    ) {
      const basicDataRequest = GetBasicDataRequest.call({
        arId,
        caseId,
        entityType,
      });
      getBasicData && getBasicData(basicDataRequest);
    }
  }, [visible]);

  /**
   *Send email
   * @param emailDetails Email address and body content
   */
  const onSendEmail = (emailDetails: IEmailFormData) => {
    try {
      const { to, subject, body } = emailDetails;
      sendTemplate &&
        sendTemplate(
          SendEmail.call({
            ...data,
            content,
            to,
            body,
            caseId,
            arId,
            entityType,
            subject,
          })
        );
    } catch (error) {}
  };

  /**
   * Execute activity
   * @param editContent - Template content
   */
  const onExecute = (editContent: Array<string>) => {
    try {
      executeTemplate &&
        executeTemplate(
          ExecuteTemplate.call({
            ...data,
            editContent,
            caseId,
            arId,
            entityType,
          })
        );
    } catch (error) {}
  };

  /**
   * Email drawer open
   */
  const onEmailDrawer = (editContent: Array<string>) => {
    setContent(editContent);
    handleDrawer &&
      handleDrawer({
        ...templateDrawer,
        type: TemplateDrawerType.EMAIL,
      });
  };

  /**
   * Email drawer close
   */
  const onEmaiDrawerClose = () => {
    handleDrawer &&
      handleDrawer({
        ...templateDrawer,
        type: TemplateDrawerType.EDITOR,
      });
  };

  /**
   * Close the drawer
   */
  const onCloseDrawer = () => {
    handleDrawer &&
      handleDrawer({
        title: "",
        visible: false,
        type: "",
        isPreview: false,
        templateDetails: messageTemplateInitial,
      });
  };

  return (
    <$Drawer
      title={templateDrawer.title}
      width={"900px"}
      open={templateDrawer.visible}
      onClose={onCloseDrawer}
      destroyOnClose
      className={
        templateDrawer.isPreview &&
        !(templateDrawer.type == TemplateDrawerType.EMAIL)
          ? "msg-template-html-parser"
          : "mtd-v2"
      }
    >
      {templateDrawer.type == TemplateDrawerType.EDITOR && (
        <Editor
          messageTemplate={templateDrawer.templateDetails}
          template={messageTemplateContent}
          onClose={onCloseDrawer}
          onExecute={onExecute}
          onOpenEmail={onEmailDrawer}
          isTemplateExecuting={isTemplateExecuting}
        />
      )}
      {templateDrawer.type == TemplateDrawerType.PREVIEW && (
        <MessageTemplateDetail
          template={messageTemplateContent}
          onClose={onCloseDrawer}
        />
      )}
      {templateDrawer.type == TemplateDrawerType.EMAIL && (
        <Email
          to={getReceiverEmailForV2(data, domainMessageBasicData)}
          item={templateDrawer.templateDetails}
          onSendEmail={onSendEmail}
          onClose={onEmaiDrawerClose}
          isSend={isEmailSending}
          subject={data?.settings?.Emailsubject}
        />
      )}
    </$Drawer>
  );
};

const {
  messageTemplates,
  deleteMessageTempale,
  messageTemplate,
  email,
  pinUnpinTemplate,
  displayName,
  messageContent,
  templateEmail,
  templateExecute,
} = messageTemplateAction;

const { basicDetail } = MessageAndNoteAction;

const mapStateToProps = (state: RootState) => {
  const { messageTemplate, domainView, messageAndNotes } = state;
  const {
    emailDrawerData,
    messageTemplateContent,
    templateDrawer,
    isEmailSending,
    isTemplateExecuting,
  } = messageTemplate;
  const { metaData } = domainView;
  const { domainMessageBasicdetail } = messageAndNotes;
  return {
    metaData,
    emailDrawerData,
    domainMessageBasicData: domainMessageBasicdetail,
    messageTemplateContent,
    templateDrawer,
    isEmailSending,
    isTemplateExecuting,
  };
};

const mapDispatchToProps = {
  getMessageTemplates: messageTemplates.get,
  deleteMessageTemplate: deleteMessageTempale.delete,
  previewEditDrawer: messageTemplate.previewEditDrawer,
  getMessageTemplateById: messageTemplate.get,
  emailDrawer: email.openDrawer,
  getBasicData: basicDetail.get,
  pinUnpinTemplate: pinUnpinTemplate.send,
  updateDisplayName: displayName.update,
  getTemplateContent: messageContent.get,
  handleDrawer: messageContent.openDrawer,
  sendTemplate: templateEmail.send,
  executeTemplate: templateExecute.execute,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(TemplateDrawer);
